import { IBaseEnvironment, IEnvironment } from '../app/types/environment';

const backEndUrl = process.env.BACKEND_URL;

const baseEnvironment: IBaseEnvironment = {
  accessManagerUrl: process.env.ACCESS_MANAGER_URL,
  baseDomain: process.env.BASE_DOMAIN,
  backEndUrl,
};

export const environment: IEnvironment = {
  ...baseEnvironment,
  apiUrl: `${backEndUrl}/`,
  recaptchaKey: process.env.RECAPTCHA_KEY,
  authClientId: process.env.AUTH_CLIENT_ID,
  authRedirectUri: process.env.AUTH_REDIRECT_URI,
};
